import type { JSX } from "solid-js";
import Text from "../../text/Text";
import { Avatar } from "../../avatar/Avatar";
import type { AvatarOption } from "../../../types/Menu";

const AvatarSelectValue = (props: Omit<AvatarOption<null>, "variant" | "value">): JSX.Element => (
  <div class="flex min-w-0 items-center gap-x-1.5 select-none">
    <Avatar size="xs" shape={props.shape} backgroundColor={props.backgroundColor} value={props.initials} />
    <Text as="span" truncate text={props.label} class="text-base-medium text-primary" />
  </div>
);

export default AvatarSelectValue;
